import {
  ADD_COMPANY_PROVIDER,
  ADD_COMPANY_PROVIDER_FAILURE,
  ADD_COMPANY_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const addCompanyProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COMPANY_PROVIDER:
      return { ...state, loading: true };
    case ADD_COMPANY_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case ADD_COMPANY_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default addCompanyProviderReducer;
